import { logEvent } from "firebase/analytics";
import { analytics } from "./config";

interface InfoObject {
    [key: string]: any; // This allows any additional properties
    // Add specific properties here if known
    userId?: string;
    actionType?: string;
}

export const analyticsHandler = (eventName: string, infoObject: InfoObject) => {
    if (analytics) {
        logEvent(analytics, eventName, infoObject);
    }
}